
interface GalleryImage {
  url: string;
  title: string;
  category: string;
}

interface GalleryGridProps {
  images: GalleryImage[];
  onImageClick: (index: number) => void;
}

export default function GalleryGrid({ images, onImageClick }: GalleryGridProps) {
  return (
    <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4">
      {images.map((image, index) => (
        <div
          key={`${image.title}-${index}`}
          className="break-inside-avoid group relative overflow-hidden rounded-xl cursor-pointer"
          onClick={() => onImageClick(index)}
        >
          <img
            src={image.url}
            alt={image.title}
            title={image.title}
            className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs text-white font-medium mb-2">
                {image.category}
              </span>
              <p className="text-white text-base font-semibold">{image.title}</p>
            </div>
          </div>
          <div className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-zoom-in-line text-white text-lg"></i>
          </div>
        </div>
      ))}
    </div>
  );
}
